import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS} from '@/queryClient'
import {httpExportMergedReportByMonth} from '@/features/accesses/activity-report/http/mergedReportExport.http'
import {
    MergedReportExportError,
    MergedReportExportRequest,
    MergedReportExportResponse
} from '@/features/accesses/activity-report/types'
import {EXPORTS_LIST_KEY_PREFIX} from '@/features/exports/query/exportsKeys'

// Enqueues the async merged-report CSV export. The returned job is followed through the shared
// exports machinery (socket + toggle + history), so on success we only refresh the exports history
// list; the card seeds the toggle dot/popover from the returned job.
export const useExportMergedReportByMonth = (
    options?: Omit<
        UseMutationOptions<MergedReportExportResponse, AxiosError<MergedReportExportError>, MergedReportExportRequest>,
        'mutationKey' | 'mutationFn'
    >
) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EXPORT_MERGED_REPORT_BY_MONTH],
        mutationFn: httpExportMergedReportByMonth,
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: EXPORTS_LIST_KEY_PREFIX})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
